import type {
  ExpenseClaimResponse,
  ExpenseClaimRouteResponse,
  TravelMovementPerDayResponse,
  TravelMovementResponse
} from 'generated/index';

export type ClaimResponse = ExpenseClaimResponse | TravelMovementPerDayResponse;
export type RouteResponse =
  | ExpenseClaimRouteResponse
  | TravelMovementResponse[];

export enum ClaimsAction {
  APPROVE = 'APPROVE',
  REVOKE = 'REVOKE',
  REJECT = 'REJECT'
}
